import _ from 'underscore';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import config from '@bingads-webui-component-legacy/config/index';
import { countNumberOfDigits } from '@bingads-webui-campaign-legacy/budget/shared/countNumberOfDigits';

const bidLimitations = config.get('KeywordBidRange');

export const validate = function(adgroups) {
  return _.every(adgroups, (adGroup) => {
    let bid = decimal.fromLocalToFloat(adGroup.Bid);

    return decimal.isValid(adGroup.Bid, true) &&
      _.isFinite(bid) &&
      _.isNumber(bid) &&
      bid >= bidLimitations.FloorValue &&
      bid <= bidLimitations.CeilingValue &&
      countNumberOfDigits(bid) <= 2;
  });
};
